import { createSlice } from "@reduxjs/toolkit";

const roleSlice = createSlice({
  name: "roles",
  initialState: [],
  reducers: {
    setRoles: (state, action) => action.payload,
  },
});

export const { setRoles } = roleSlice.actions;
export default roleSlice.reducer;
